import { Box, Flex } from '@pancakeswap/uikit'
import styled from 'styled-components'

export const StyledSwapContainer = styled(Flex)<{ $isChartExpanded: boolean }>`
  flex-shrink: 0;
  height: fit-content;
  padding: 0 24px;

  ${({ theme }) => theme.mediaQueries.lg} {
    padding: 0 40px;
  }

  ${({ theme }) => theme.mediaQueries.xxl} {
    ${({ $isChartExpanded }) => ($isChartExpanded ? 'padding: 0 120px' : 'padding: 0 40px')};
  }
`

export const StyledInputCurrencyWrapper = styled(Box)`
  width: 328px;
`

export const SuccessMessagePanel = styled.div`
  width: 100%;
  background: #ffffff;
  border: 1px solid #5fcd6b;
  border-radius: 8px;
  padding: 16px;

  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #20242e;

  margin-bottom: 24px;
  margin-top: 24px;
  display: flex;
`

export const ErrorMessagePanel = styled.div`
  width: 100%;
  background: #ffffff;
  border: 1px solid #d54238;
  border-radius: 8px;
  padding: 16px;

  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #20242e;

  margin-bottom: 24px;
  margin-top: 24px;
  display: flex;
`

export const MessagePanelTextContainer = styled.div`
  padding-left: 8px;
`

export const MessagePanelTitle = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: #20242e;
`
